import moment from "moment";

/**
 * Format the date-time pickers hand back to the API.
 *
 * `mm` is minutes. `MM` is months - and the reminder forms were all using
 * `HH:MM`, so a reminder set for 14:08 in September was saved as 14:09.
 */
export const FORM_DATE_TIME_FORMAT = "YYYY-MM-DD HH:mm";

/**
 * Turns a stored reminder timestamp (unix seconds) into a value a picker can be
 * prefilled with, or `null` when nothing was ever saved.
 *
 * `moment.unix(null)` does not fail loudly - it quietly becomes the epoch,
 * which is why an empty "Resend Date & Time" came back prefilled as
 * 01/02/1970 08:00 PM instead of staying empty.
 *
 * The result is an ISO string on purpose: the pickers re-parse this value with
 * dayjs, and a locale string like "Thu, Jan 1, 1970 5:30 AM" is not something
 * dayjs parses reliably.
 */
export const reminderDateToFormValue = (value) => {
  if (value === null || value === undefined || value === "") return null;

  // Already a date or a parseable string (an unsaved edit still in the form).
  if (typeof value !== "number" && !/^\d+$/.test(String(value).trim())) {
    const parsed = moment(value);
    return parsed.isValid() ? parsed.toISOString() : null;
  }

  const seconds = Number(value);
  if (!Number.isFinite(seconds) || seconds <= 0) return null;

  const parsed = moment.unix(seconds);
  return parsed.isValid() ? parsed.toISOString() : null;
};

const reminderDate = { FORM_DATE_TIME_FORMAT, reminderDateToFormValue };

export default reminderDate;
